<template>
  <div>
    <!-- Backdrop -->
    <div v-if="isOpen" 
      class="modal-backdrop fade show"
      @click="closeModal"
    ></div>
    
    <!-- Modal -->
    <div class="modal fade" :class="{ 'show d-block': isOpen }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title">
              {{ idTubeFL ? 'Modifica tubo FluorTecno' : 'Nuovo tubo FluorTecno' }}
            </h5>
            <argon-button type="button" color="light" @click="closeModal" aria-label="Close">X</argon-button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <vee-form :validation-schema="tubeFLSchema" @submit="saveTubeFL">
                <argon-alert color="danger" v-if="show_alert">{{ alert_msg }}</argon-alert>
                <argon-alert color="success" v-if="show_success">{{ alert_msg }}</argon-alert>

                <div class="row">
                    <div class="col-md-3">
                        <label for="factory_number" class="form-control-label">Numero di fabbrica</label>
                        <vee-field type="text" class="form-control" name="factory_number" id="factory_number"
                            placeholder="Numero di fabbrica" v-model="this.tubeFL.factory_number"
                        />
                        <error-message class="text-danger text-xs" name="factory_number"/>
                    </div>
                    <div class="col-md-3">
                        <label for="serial_number" class="form-control-label">Numero di matricola</label>
                        <vee-field type="text" class="form-control" name="serial_number" id="serial_number"
                            placeholder="Numero di matricola" v-model="this.tubeFL.serial_number"/>
                    </div>
                    
                    <div class="col-md-3">
                      <label for="area" class="form-control-label">Reparto</label>
                      <vee-field type="text" class="form-control" name="area" id="area"
                        placeholder="Area" v-model="this.tubeFL.area"
                      />
                    </div>
                    <div class="col-md-3">
                      <label for="substance" class="form-control-label">Sostanza/TAG</label>
                      <vee-field type="text" class="form-control" name="substance"
                        id="substance" placeholder="Sostanza" v-model="this.tubeFL.substance"
                      />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.type"
                        :list="this.types"
                        :label="'Tipo'"
                        :placeholder="'Seleziona o digita il Tipo'"
                        :field-name="'type'"
                      ></select-autocomplete>
                      <error-message class="text-danger text-xs" name="type" />
                    </div>
                    <div class="col-md-3">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.dp"
                        :list="this.dpList"
                        :label="'DP'"
                        :placeholder="'Seleziona o digita il DP'"
                        :field-name="'dp'"
                      ></select-autocomplete>
                      <error-message class="text-danger text-xs" name="dp" />
                    </div>
                    <div class="col-md-3">
                      <label for="lg" class="form-control-label">Lg (mm)</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="lg"
                        id="lg"
                        placeholder="Lg"
                        v-model="this.tubeFL.lg"
                      />
                      <error-message class="text-danger text-xs" name="lg" />
                    </div>
                    <div class="col-md-3">
                      <label for="color" class="form-control-label">Colore</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="color"
                        id="color"
                        placeholder="Colore"
                        v-model="this.tubeFL.color"
                      />
                      <error-message class="text-danger text-xs" name="color" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.fitting_right"
                        :list="this.fittings"
                        :label="'Raccordo dx'"
                        :placeholder="'Seleziona o digita il raccordo dx'"
                        :field-name="'fitting_right'"
                      ></select-autocomplete>
                      <error-message
                        class="text-danger text-xs"
                        name="fitting_right"
                      />
                    </div>
                    <div class="col-md-4">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.measure_right"
                        :list="this.measures"
                        :label="'Misura'"
                        :placeholder="'Seleziona o digita la misura'"
                        :field-name="'measure_right'"
                      ></select-autocomplete>
                      <error-message class="text-danger text-xs" name="measure_right"/>
                    </div>
                    <div class="col-md-4">
                      <label for="material_right" class="form-control-label">Materiale</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="material_right"
                        id="material_right"
                        placeholder="Materiale"
                        v-model="this.tubeFL.material_right"
                      />
                      <error-message class="text-danger text-xs" name="material_right"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.fitting_left"
                        :list="this.fittings"
                        :label="'Raccordo sx'"
                        :placeholder="'Seleziona o digita il raccordo sx'"
                        :field-name="'fitting_left'"
                      ></select-autocomplete>
                      <error-message class="text-danger text-xs" name="fitting_left"/>
                    </div>
                    <div class="col-md-4">
                      <select-autocomplete
                        v-model:input-model="this.tubeFL.measure_left"
                        :list="this.measures"
                        :label="'Misura'"
                        :placeholder="'Seleziona o digita la misura'"
                        :field-name="'measure_left'"
                      ></select-autocomplete>
                      <error-message
                        class="text-danger text-xs"
                        name="measure_left"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="material_left" class="form-control-label">Materiale</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="material_left"
                        id="material_left"
                        placeholder="Materiale"
                        v-model="this.tubeFL.material_left"
                      />
                      <error-message class="text-danger text-xs" name="material_left"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                      <label for="client_code" class="form-control-label">Venduto a</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="client_code"
                        id="client_code"
                        placeholder="Codice cliente"
                        v-model="this.tubeFL.client_code"
                      />
                      <error-message class="text-danger text-xs" name="client_code"/>
                    </div>
                    <div class="col-md-8">
                      <label for="client_name" class="form-control-label">Ragione sociale</label>
                      <vee-field
                        type="text"
                        class="form-control"
                        name="client_name"
                        id="client_name"
                        placeholder="Ragione sociale"
                        v-model="this.tubeFL.client_name"
                        disabled
                      />
                    </div>
                </div>

                <!-- Footer con pulsanti -->
                <div class="d-flex justify-content-end gap-2 mt-4">
                    <argon-button color="dark" type="button"  @click="closeModal">
                        Annulla
                    </argon-button>
                    <argon-button color="success" type="submit">
                        Salva
                    </argon-button>
                </div>
            </vee-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import axios from "axios";
import { ErrorMessage } from "vee-validate";
import { TubeFLModel } from "@/models/tubefl/tubefl.model";
import SelectAutocomplete from "@/views/tube/selectAutocomplete.vue";

export default {
  name: "tubefl-modal",
  components: { 
    ArgonAlert, 
    ArgonButton, 
    ErrorMessage, 
    SelectAutocomplete 
},
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    idTubeFL: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
        tubeFLSchema: {
            factory_number: "required",
            serial_number: "required",
            type: "required",
            dp: "required",
            lg: "required",
            color: "required",
            fitting_left: "required",
            fitting_right: "required",
            measure_left: "required",
            measure_right: "required",
            material_left: "required",
            material_right: "required",
        },
        show_alert: false,
        show_success: false,
        alert_msg: "",
        tubeFL: new TubeFLModel(),
        types: [],
        dpList: [],
        fittings: [],
        measures: [],
        searchTimeout: null,
    };
  },
  watch: {
    async isOpen(newVal) {
      if (newVal) {
        this.resetForm();
        // Carica le liste quando si apre la modale
        await this.loadAllLists();
        if (this.idTubeFL) {
          this.getTubeFL();
        }
      }
    },
    'tubeFL.client_code': {
      handler: function(newCode) {
        // Cancella il timeout precedente
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        
        // Se il codice è vuoto, svuota il nome
        if (!newCode || newCode.trim() === '') {
          this.tubeFL.client_name = '';
          return;
        }
        
        // Debounce: attendi 500ms prima di cercare
        this.searchTimeout = setTimeout(() => {
          this.searchCustomerByCode();
        }, 500);
      },
      deep: true
    }
  },
  methods: {
    closeModal() {
      this.resetForm();
      this.$emit('close');
    },
    async resetForm() {
        this.tubeFL = new TubeFLModel();
        await this.loadAllLists();
        this.show_alert = false;
        this.show_success = false;
        this.alert_msg = "";

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
        }
    },
    async loadAllLists() {
      try {
        await Promise.all([
          this.getTypeList(),
          this.getDPList(),
          this.getFittingList(),
          this.getMeasureList()
        ]);
      } catch (error) {
        console.error("Errore nel caricamento delle liste:", error);
        this.show_alert = true;
        this.alert_msg = "Errore nel caricamento dei dati iniziali";
      }
    },
    async getTubeFL() {
      try {
        if (this.idTubeFL) {
          const response = await axios.get(
            this.$endpoint + "/tubefl/show/" + this.idTubeFL,
            {
              headers: {
                authorization: process.env.VUE_APP_APY_KEY,
              },
            }
          );

          if (response.data.status === "OK") {
            this.tubeFL = response.data.data;
            // Se ha un client_code, cerca il nome del cliente
            if (this.tubeFL.client_code) {
              await this.searchCustomerByCode();
            }
          }
        }
      } catch (e) {
        console.log(e.toString());
        this.show_alert = true;
        this.alert_msg = "Errore nel caricamento dei dati";
      }
    },
    async searchCustomerByCode() {
      const code = this.tubeFL.client_code;
      
      // Se il codice è vuoto, non fare nulla
      if (!code || code.trim() === '') {
        this.tubeFL.client_name = '';
        return;
      }
      
      try {
        const response = await axios.get(
          `${this.$endpoint}/customer/check/${encodeURIComponent(code.trim())}`,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        if (response.data.status === "OK" && response.data.exists) {
          this.tubeFL.client_name = response.data.data.name;
        } else {
          // Cliente non trovato: svuota il nome
          this.tubeFL.client_name = '';
        }
      } catch (error) {
        console.error("Errore ricerca cliente:", error);
        this.tubeFL.client_name = '';
      }
    },
    async saveTubeFL() {
      try {
        // Nascondi eventuali alert precedenti
        this.show_alert = false;
        this.show_success = false;

        // Controllo presenza client_code nel Customer prima del salvataggio
        if (this.tubeFL.client_code && this.tubeFL.client_code.trim() !== '') {
            try {
                const customerCheck = await axios.get(
                `${this.$endpoint}/customer/check/${encodeURIComponent(this.tubeFL.client_code.trim())}`,
                { 
                    headers: {
                    authorization: process.env.VUE_APP_APY_KEY,
                    }
                }
                );

                if (customerCheck.data.status === "OK") {
                    if (!customerCheck.data.exists) {
                        this.show_alert = true;
                        this.alert_msg = `Il codice cliente "${this.tubeFL.client_code}" non esiste nell'anagrafica clienti`;
                        return; // Interrompe il salvataggio
                    }
                    
                    // Popola automaticamente il nome cliente se disponibile
                    if (customerCheck.data.data && customerCheck.data.data.name) {
                        this.tubeFL.client_name = customerCheck.data.data.name;
                    }
                } else {
                    this.show_alert = true;
                    this.alert_msg = "Errore nella verifica del cliente";
                return;
                }
            } catch (checkError) {
                console.error("Errore verifica cliente:", checkError);
                this.show_alert = true;
                
                if (checkError.response) {
                    this.alert_msg = checkError.response.data?.message || "Errore nella verifica del codice cliente";
                } else if (checkError.request) {
                    this.alert_msg = "Errore di connessione durante la verifica del cliente";
                } else {
                    this.alert_msg = "Impossibile verificare il codice cliente";
                }
                return;
            }
        }

        const response = await axios.post(
          `${this.$endpoint}/tubefl/add`,
          {
            tubeFL: this.tubeFL
          },
          {
            params: { id: this.idTubeFL },
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        if (response.data.status === "OK") {
            this.show_success = true;
            this.alert_msg = this.idTube 
                ? "Tubo FluorTecno aggiornato con successo" 
                : "Tubo FluorTecno creato con successo";
            
            const savedData = response.data.data || this.tubeFL;
            
            // Assicurati che l'oggetto abbia l'_id
            if (this.idTubeFL && !savedData._id) {
                savedData._id = this.idTubeFL;
            }

            this.$emit('saved', response.data.data);
          
            setTimeout(() => {
                this.$emit('saved', response.data.data);
                this.closeModal();
            }, 1500);
            
        } else {
            this.show_alert = true;
            this.alert_msg = response.data.message;
        }
        
      } catch (error) {
        this.show_alert = true;
        
        if (error.response) {
          this.alert_msg = error.response.data?.message || "Errore nel salvataggio del tubo FluorTecno";
        } else if (error.request) {
          this.alert_msg = "Errore di connessione al server";
        } else {
          this.alert_msg = "Errore imprevisto nel salvataggio";
        }
        
        console.error("Errore salvataggio tubo FluorTecno:", error);
      }
    },
    async getTypeList() {
      try {
        const response = await axios.get(this.$endpoint + "/type/list", {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        if (response.data.status === "OK") {
            const data = JSON.parse(response.data.data);
            this.types = Array.isArray(data) ? data.filter((item) => item.enabled === true): [];
        }
        return [];
      } catch (e) {
        console.error("Errore caricamento types:", e.toString());
        this.types = [];
      }
    },
    async getDPList() {
      try {
        const response = await axios.get(this.$endpoint + "/dp/list", {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        if (response.data.status === "OK") {
          this.dpList = JSON.parse(response.data.data);
          this.dpList = this.dpList.filter((item) => item.enabled === true);
        }
        return [];
      } catch (e) {
        console.log(e.toString());
      }
    },
    async getFittingList() {
      try {
        const response = await axios.get(this.$endpoint + "/fitting/list", {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        if (response.data.status === "OK") {
          this.fittings = JSON.parse(response.data.data);
          this.fittings = this.fittings.filter((item) => item.enabled === true);
        }
        return [];
      } catch (e) {
        console.log(e.toString());
      }
    },
    async getMeasureList() {
      try {
        const response = await axios.get(this.$endpoint + "/measure/list", {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        if (response.data.status === "OK") {
          this.measures = JSON.parse(response.data.data);
          this.measures = this.measures.filter((item) => item.enabled === true);
        }
        return [];
      } catch (e) {
        console.log(e.toString());
      }
    },
  },
  beforeUnmount() {
    // Pulisci il timeout quando il componente viene distrutto
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
}

.modal.show {
  display: block;
  z-index: 1050;
}

.gap-2 {
  gap: 0.5rem;
}
</style>